import type { BlockNumericQuestion } from 'shared-types';

type LocaleData = BlockNumericQuestion['locales'][string];

const defaultBlockData = {
  correctAnswer: 0,
  isMandatory: false,
  pointsWeight: 2,
  requireAnswerToProceed: false
};

const translatable: LocaleData['translatable'] = {
  feedback: '',
  feedbackCorrect: '',
  feedbackIncorrect: '',
  question: ''
};
const defaultLocaleData: LocaleData = { translatable };

const localePlaceholders = {
  feedback: '{{ locales.translatable.feedback }}' as const,
  feedbackCorrect: '{{ locales.translatable.feedbackCorrect }}' as const,
  feedbackIncorrect: '{{ locales.translatable.feedbackIncorrect }}' as const,
  question: '{{ locales.translatable.question }}' as const
};

export const defaults = {
  defaultBlockData,
  defaultLocaleData,
  localePlaceholders
};

export const blockNumericQuestionData: BlockNumericQuestion = {
  ...defaultBlockData,
  ...localePlaceholders,
  locales: new Proxy({} as BlockNumericQuestion['locales'], {
    get: (locales, languageVersion: string) => {
      return (locales[languageVersion] = defaultLocaleData);
    }
  })
};
